import FaqPage from 'pages/faq';

export default FaqPage;
